export default "__VITE_ASSET__gi5rp70X__"